"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryString = void 0;
// Rexport for dynamic require
var useQueryString_1 = require("./useQueryString");
Object.defineProperty(exports, "useQueryString", { enumerable: true, get: function () { return useQueryString_1.useQueryString; } });
//# sourceMappingURL=index.js.map